<template>
	<div class="frame-page">
		<slot/>
	</div>
</template>

<script>
	export default {
		name: "AppContent",
		props: {
			title: String
		},
		data() {
			return {
				minHeight: (window.innerHeight - 102) + 'px'
			}
		},
		mounted() {
			window.document.title = 'AI模范 - ' + (this.title || this.$route.meta.title);
		}
	}
</script>

<style scoped>

</style>
